'use client';

import Footer from './footer/Footer';
import styles from '../../styles/global/general.module.scss';

/**
 * Wrapper за страници с Footer – flex layout, така че съдържанието да запълва екрана.
 * hideFooterOnMobile: при true футърът се скрива само на мобилно (напр. project страницата).
 */
export default function PageWithFooter({ children, hideFooterOnMobile = false }) {
  return (
    <div
      className={styles.pageWithFooter}
      {...(hideFooterOnMobile && { 'data-hide-footer-mobile': 'true' })}
    >
      <div className={styles.mainGrow}>{children}</div>
      <Footer />
    </div>
  );
}
